app.factory('secretKeyInteceptor', ['md5', function (md5) {
    var secretInjector = {
        request: function (config) {
            config.headers['secret-key'] = md5.createHash(Math.round(new Date().getTime() / 1000000) + "TheAppSecret")
            return config;
        }
    };
    return secretInjector;
}]);
app.config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('secretKeyInteceptor');
}]);